import React, { useState, useEffect, useRef } from 'react';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';
// import { AiOutlineClose } from 'react-icons/ai';

import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { toast } from 'sonner';
import DeleteModal from '../common/DeleteModal';
import twiterIcon from "../../assets/Icons/twitter (3) 1.png"
import youtubeIcon from "../../assets/Icons/video 1.png"
import socialPin from "../../assets/social-pin.png"

const SocialMedia = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [linkType, setLinkType] = useState('Linkedin');
    const [socialLink, setSocialLink] = useState('');
    const [errors, setErrors] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [socialLinksList, setSocialLinksList] = useState([]);
    const [editId, setEditId] = useState(null); // Store the ID of the link being edited
    const [modalForm, setModalForm] = useState(false); // For Delete Modal
    const [noteIdToDelete, setNoteIdToDelete] = useState(null); // ID of the link to delete
    const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false); // For success modal after delete

    const modalRef = useRef(); // Reference to the modal

    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
    const XIcon = ({ className }) => (
        <img src={twiterIcon}></img>
    );
    const Youtube = ({ className }) => (
        <img src={youtubeIcon}></img>
    );
    const socialMediaIcons = {
        Linkedin: <FaLinkedin className="text-blue-700 text-2xl" />,
        Twitter: <XIcon className="text-black text-2xl" />,
        Instagram: <FaInstagram className=" text-white text-2xl rounded-lg"
            style={{
                background: 'linear-gradient(45deg, #FFDD55, #FF543E, #C837AB)',
                padding: "2px"
            }} />,
        Facebook: <FaFacebook className="text-blue-600 text-2xl" />,
        Youtube: <Youtube className="text-red-600 text-2xl" />,
    };

    // Fetch the list of social media links
    const fetchSocialLinks = () => {
        Postdata(HttpService.school_social_media_list)
            .then((res) => {
                if (res.status === 200) {
                    setSocialLinksList(res.data);
                }
            })
            .catch((err) => {
                // toast.error(err.response.data.message);
                console.error(err);
            });
    };

    // Fetch social links when the component mounts or after a new link is added/updated
    useEffect(() => {
        fetchSocialLinks();
    }, []);

    // Handle click outside to close the modal
    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (modalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
                setModalOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [modalOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();

        setErrors({});

        let formErrors = {};
        if (!linkType) {
            formErrors.linkType = 'Please select a social media platform';
        }
        if (!socialLink.trim()) {
            formErrors.socialLink = 'Please enter a valid social media link';
        } else if (!urlPattern.test(socialLink.trim())) {
            formErrors.socialLink = 'Please enter a valid URL format';
        }

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }

        const formData = {
            platform: linkType,
            link: socialLink,
        };

        // If editing, include the ID in the request body
        if (editId) {
            formData.id = editId;
        }

        Postdata(HttpService.school_social_media_add, formData)
            .then((res) => {
                if (res.status === 200) {
                    toast.success(editId ? 'Social media link updated successfully!' : 'Social media link added successfully!');
                    if (editId) {
                        // Update the list with the edited link
                        setSocialLinksList((prevList) =>
                            prevList.map((item) =>
                                item._id === editId ? { ...item, platform: linkType, link: socialLink } : item
                            )
                        );
                    } else {
                        setSocialLinksList((prevList) => [...prevList, { ...formData, _id: res.data._id }]);
                    }
                } else {
                    toast.error(res.message);
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
                console.error(err?.response?.data?.message);
            });

        setModalOpen(false);
        setEditId(null); // Reset the edit ID after submission
    };

    const handleEdit = (item) => {
        setLinkType(item.platform);
        setSocialLink(item.link);
        setEditId(item._id); // Store the ID of the item being edited
        setModalOpen(true);
    };

    const handleDeleteClick = (id) => {
        setNoteIdToDelete(id);
        setModalForm(true);
    };

    const handleDelete = () => {
        if (noteIdToDelete) {
            Postdata(HttpService.school_social_media_delete, { id: noteIdToDelete })
                .then((res) => {
                    if (res.status === 200) {
                        toast.success('Social media link deleted successfully!');
                        setSocialLinksList((prevList) =>
                            prevList.filter((item) => item._id !== noteIdToDelete)
                        );
                    } else {
                        toast.error('Error deleting social media link');
                    }
                    setModalForm(false); // Close the modal
                    setModalOpenDeleteSuccess(true); // Show success modal
                })
                .catch((err) => {
                    toast.error('An error occurred, please try again later.');
                    console.error(err);
                });
        }
    };

    return (
        <div className="rounded-lg p-6 relative text-gray-800 mx-auto">
            <div className="flex justify-end">
                <button
                    className="button-small-primary"
                    onClick={() => {
                        setModalOpen(true);
                        setSocialLink('');
                        setLinkType('Linkedin');
                        setEditId(null); // Ensure editId is reset when adding a new link
                    }}
                >
                    + Add Link
                </button>
            </div>

            <div className="mt-4 space-y-4">
                {socialLinksList.length > 0 ? (
                    socialLinksList.map((item, index) => (
                        <div className='mb-4'>
                            <div className='mb-2'>{item.platform}<span className="required">*</span></div>
                            <div key={index} className="flex items-center justify-between p-2 px-3 border border-gray-300 bg-white rounded-2xl">
                                <div className="flex items-center space-x-2">
                                    {socialMediaIcons[item.platform]}
                                    <a href={item.link} target="_blank" className="text-blue-700 cursor-pointer underline">
                                        {item.link}
                                    </a>
                                </div>
                                <div className="flex space-x-2">
                                    <button
                                        className="text-red-500 button-small-secondary"
                                        onClick={() => handleDeleteClick(item._id)} // Trigger delete modal
                                    >
                                        Delete
                                    </button>
                                    <button
                                        className="text-blue-500 button-small-primary"
                                        onClick={() => handleEdit(item)} // Trigger edit mode
                                    >
                                        Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="h-[50vh] flex items-center justify-center w-full">
                        <h1 className="text-center text-gray-400">No social media links found.</h1>
                    </div>
                )}
            </div>

            {/* Modal */}
            {modalOpen && (
                <div
                    className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50"
                >
                    <div className="bg-white p-6 rounded-lg w-98 " ref={modalRef}>
                        <h2 className="text-2xl font-semibold mb-4 flex items-center justify-center">{editId ? 'Edit Social Media Link' : 'Add Social Media Link'}</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <div className="relative">
                                    <button
                                        type="button"
                                        className="border border-gray-300 bg-slate-100 rounded-md p-2 w-full flex items-center justify-between"
                                        onClick={() => setDropdownOpen(!dropdownOpen)}
                                    >
                                        <span className="flex items-center">
                                            {socialMediaIcons[linkType]}
                                            <span className="ml-2">{linkType}</span>
                                        </span>
                                        <span>▼</span>
                                    </button>
                                    {dropdownOpen && (
                                        <div className="absolute w-full mt-1 bg-slate-100 border border-gray-300 rounded-md shadow-md z-10">
                                            {Object.keys(socialMediaIcons).map((platform) => (
                                                <button
                                                    key={platform}
                                                    type="button"
                                                    onClick={() => {
                                                        setLinkType(platform);
                                                        setDropdownOpen(false);
                                                    }}
                                                    className="w-full flex items-center p-2 hover:bg-gray-100"
                                                >
                                                    {socialMediaIcons[platform]}
                                                    <span className="ml-2">{platform}</span>
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                {errors.linkType && (
                                    <p className="text-red-500 text-sm">{errors.linkType}</p>
                                )}
                            </div>

                         <div className="mb-2 relative">
                            <input
                                type="text"
                                id="socialLink"
                                value={socialLink}
                                onChange={(e) => setSocialLink(e.target.value)}
                                placeholder="Add Social Media Link"
                                className="border border-gray-300 bg-slate-100 rounded-md px-10 py-2 w-full"
                            />
                            <div className="absolute left-3 p-2 top-1/2 transform -translate-y-1/2">
                                <img src={socialPin} alt="pin" className="w-4 h-4" />
                            </div>
                        </div>
                            {errors.socialLink && (
                                <p className="text-red-500 text-sm">{errors.socialLink}</p>
                            )}

                            <div className="w-full flex justify-between gap-3 mb-2 mt-4">
                                <button
                                    type="button"
                                    onClick={() => setModalOpen(false)}
                                    className="button-field-secondary"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="button-field-primary"
                                >
                                    {editId ? 'Update' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Delete Modal */}
            <DeleteModal
                title="Delete Social Media Link"
                message="Are you sure you want to delete this social media link? It will be removed permanently."
                modalOpenDelete={modalForm}
                setmodalOpenDelete={setModalForm}
                handleDelete={handleDelete}
                selectedId={noteIdToDelete}
                setSelectedId={setNoteIdToDelete}
                modalOpenDeleteSuccess={modalOpenDeleteSuccess}
                setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
                redirectPage={"Social Media"}
                redirectUrl={"settings"}
                module={"Social Media Link"}
            />
        </div>
    );
};

export default SocialMedia;
